/**
 * Brings the first field marked invalid on the page into view.
 *
 * A multi-step form validates a whole step at once; on a long step (the last
 * one carries the transporters and the declaration) the field that failed can
 * sit far above the button the user just pressed — so without this the press
 * looks like it did nothing.
 */
export function scrollToFirstError() {
	requestAnimationFrame(() => {
		const el = document.querySelector("[data-invalid='true'], [aria-invalid='true'], .text-danger");
		el?.scrollIntoView({ behavior: "smooth", block: "center" });
	});
}
